import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { Fetch } from "../../../shared/Fetch";
import { JVDate } from "../../../shared/JVDate";
import { IUsersDropdown, ICompanyMastDropdown, IBranchMastDropdown, ITeamsDropdown } from "../../../models/IDropdown";
import { JVDropdown } from "../../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { ILogin } from "../../../models/Login";
import { Dropdown } from "primereact/dropdown";

export interface ISalRepFilter {
    fromDate?: Date | null,
    toDate?: Date | null,
    company_ID?: number | null,
    branch_ID?: number | null,
    salesManager_ID?: number | null,
}

export const EmptySalRepFilter: ISalRepFilter = {
    fromDate: new Date,
    toDate: new Date,
    company_ID: null,
    branch_ID: null,
    salesManager_ID: null,
}

interface Iprops {
    salRepFilter: ISalRepFilter,
    setSalEffFilter: (salEffFilter: ISalRepFilter) => void,
    onSearch: () => void;
}

export const Filter = (props: Iprops) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [sm, setSM] = useState<Array<IUsersDropdown>>();
    const [selectedBranch, setSelectedBranch] = useState<Array<number>>([]);
     const [selectedSm, setselectedSm] = useState<any | null>(null);
    const { control, handleSubmit, reset, watch } = useForm<ISalRepFilter>({
        defaultValues: props.salRepFilter,
        shouldFocusError: false
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });


    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        let endPoint = loginObj.id === 1346 ? "allBranches" : "reqBranchList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    };

    const loadCompanies = async () => {
        let endPoint = loginObj.id === 1346 ? "company" : "reqCompanyList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    };


    const loadSm = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch != null && branch != 0) {
            // queryParameter = `branch_ID=${branch}`;
            queryParameter = `branch_ID=${branch}`;

        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersListss", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSM(data);
        }
    }


    const searchToDB = async (body: ISalRepFilter) => {
        // onHide();
        let filterData: any = body;
        let emptyFilter: any = EmptySalRepFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setSalEffFilter(body);
    }

    function onSubmit(data: ISalRepFilter) {
        //if (selectedBranch.length > 0) data.branch = selectedBranch;
        searchToDB(data);
        props.onSearch();
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company_ID") {
                if (value.company_ID != 0 && value.company_ID != null) {
                    loadSm(0, value.company_ID, 0);
                    loadBranches(value.company_ID);
                } else {
                    if (value.company_ID === 0 && value.company_ID != null) {
                        loadBranches();
                        loadSm(control._formValues.branch, value.company_ID, control._formValues.team);
                    }
                }
            }

            if (name === "branch_ID") {
                if (value.branch_ID != 0 && value.branch_ID != null) {
                    loadSm(value.branch_ID, 0, 0);
                } else {
                    if (value.branch_ID === 0 && value.branch_ID != null) {

                        loadSm(control._formValues.branch, value.company_ID, control._formValues.team);
                    }
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        if (selectedBranch.length > 0) {
            //  loadSm(selectedBranch, 0, 0); // Pass the entire array
        }
    }, [selectedBranch]);

    useEffect(() => {
        loadSm(0, 0, 0);
        loadCompanies();
        loadBranches();
    }, []);
 
    

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
            <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
            <JVDropdown column={6} label="Company" control={control} name="company_ID" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
            <JVDropdown column={6} label="Branch" control={control} name="branch_ID" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />
            <div className="field col-2 md:col-2">
                <p>Sales Manager</p>
                <Dropdown value={selectedSm} style={{ height: "37px", marginTop: "-10px" }} onChange={(e) => { setselectedSm(e.value); }} options={sm} optionLabel="user_Name" placeholder="Select Sales Manager" optionValue="login_ID" filter />
            </div>
            {/* <JVDropdown column={6} label="Sales Manager" control={control} name="salesManager_ID" options={sm} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales Manager" /> */}
            <div style={{ margin: '10px 0', width: '100%' }}></div>
            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptySalRepFilter); setSelectedBranch([]);setselectedSm(0); }} type="button"></Button>
            </div>
        </form>
    );
}
